module.exports = __webpack_public_path__ + "static/media/sketch-road-glide-special.d14cd846.png";